import fetchApi, { isFetchError } from "@lib/api-fetcher/fetchApi";
import { API_ROUTES } from "@utils/constants";
import { reportError } from "@utils/errorReporting";

import { TErrorMessages, TForgotPasswordFieldError } from "../types";
import mapErrorsToMessages from "../utils/mapForgotPasswordErrorsToMessages";

const resetPassword = async (
  email: string
): Promise<{ isSuccess: boolean } & Partial<TErrorMessages<TForgotPasswordFieldError>>> => {
  try {
    await fetchApi({
      url: API_ROUTES.PASSWORD_RESET,
      method: "POST",
      data: { email },
    });
    return { isSuccess: true };
  } catch (err) {
    if (isFetchError(err) && err.response?.status === 422) {
      const { errorMessage, fieldErrors } = mapErrorsToMessages(err);
      return { isSuccess: false, errorMessage, fieldErrors };
    }

    reportError(err, { module: "password-recovery" });
    return { isSuccess: false };
  }
};
export default resetPassword;
